var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreeD(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.96 71.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.51,65.25H41.79V59.64H58.23V36h5.62V59.92A5.34,5.34,0,0,1,58.51,65.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.57,72H10.38A10.4,10.4,0,0,1,0,61.57V10.38A10.4,10.4,0,0,1,10.38,0H61.57A10.4,10.4,0,0,1,72,10.38V61.57A10.4,10.4,0,0,1,61.57,72ZM10.38,5A5.38,5.38,0,0,0,5,10.38V61.57A5.39,5.39,0,0,0,10.38,67H61.57A5.4,5.4,0,0,0,67,61.57V10.38A5.39,5.39,0,0,0,61.57,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.14,61.34a8.57,8.57,0,1,1,8.56-8.56A8.57,8.57,0,0,1,19.14,61.34Zm0-12.13a3.57,3.57,0,1,0,3.56,3.57A3.57,3.57,0,0,0,19.14,49.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.82,27.66a8.57,8.57,0,1,1,8.57-8.57A8.57,8.57,0,0,1,52.82,27.66Zm0-12.13a3.57,3.57,0,1,0,3.57,3.56A3.56,3.56,0,0,0,52.82,15.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36,44.54A8.57,8.57,0,1,1,44.54,36,8.58,8.58,0,0,1,36,44.54Zm0-12.13A3.57,3.57,0,1,0,39.54,36,3.57,3.57,0,0,0,36,32.41Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeD);
export default __webpack_public_path__ + "static/media/threeD.f92ce4e3.svg";
export { ForwardRef as ReactComponent };